module.exports = __webpack_public_path__ + "static/img/banner3.253de3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/banner3.jpg
// module id = uXzd
// module chunks = 1